import React from 'react';
import ToolbarIcon from './ToolbarIcon';

export const IconUpload = (props) => (
  <ToolbarIcon viewBox="0 0 64 64" {...props}>
    <g id="Pfad_946">
      <path d="m24.198,49.068h-9.747c-3.625-.022-7.095-1.566-9.534-4.234-5.182-5.724-5.182-14.351-.004-20.069,2.437-2.674,5.909-4.22,9.527-4.245h.32c.351-4.198,2.075-8.156,4.947-11.295,6.097-6.773,16.584-7.323,23.365-1.217.429.384.837.797,1.224,1.226,2.868,3.13,4.591,7.088,4.942,11.286h.311c3.625.024,7.095,1.57,9.529,4.236,5.187,5.726,5.187,14.351.004,20.069-2.439,2.672-5.909,4.218-9.525,4.24h-9.762c-.942,0-1.706-.764-1.706-1.706s.764-1.706,1.706-1.706h9.751c2.657-.018,5.215-1.155,7.012-3.125,3.994-4.407,3.994-11.062-.004-15.475-1.793-1.964-4.351-3.103-7.017-3.121h-1.939c-.453,0-.888-.182-1.211-.502-.32-.322-.498-.76-.495-1.213.022-3.967-1.442-7.763-4.12-10.689-.315-.351-.64-.675-.982-.982-5.387-4.851-13.71-4.416-18.556.971-2.688,2.939-4.152,6.735-4.129,10.7.002.453-.175.891-.495,1.213-.322.32-.757.502-1.211.502h-1.948c-2.657.018-5.218,1.159-7.015,3.128-3.992,4.409-3.992,11.064.004,15.48,1.795,1.961,4.356,3.099,7.021,3.116h9.736c.942,0,1.706.764,1.706,1.706s-.764,1.706-1.706,1.706Z" />
    </g>
    <g>
      <g id="Linie_339">
        <path d="m31.997,33.757c.942,0,1.706.764,1.706,1.706v24.596c0,.942-.764,1.706-1.706,1.706s-1.706-.764-1.706-1.706v-24.596c0-.942.764-1.706,1.706-1.706Z" />
      </g>
      <g id="Pfad_947">
        <path d="m31.997,33.757c.438,0,.873.167,1.206.5l6.348,6.348c.666.666.666,1.746,0,2.412s-1.746.666-2.412,0l-5.142-5.142-5.142,5.142c-.666.666-1.746.666-2.412,0s-.666-1.746,0-2.412l6.348-6.348c.333-.333.769-.5,1.206-.5Z" />
      </g>
    </g>
  </ToolbarIcon>
);

export default IconUpload;
